var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("申请签名： "+_vm._s(_vm.task.content.tip))]),_c('ul',[_c('li',[_vm._v("申请人 "+_vm._s(_vm.task.j_sender.realname))]),_c('li',[_vm._v("申请时间 "+_vm._s(_vm.task.insert_time))]),_c('li',[_vm._v("申请公司 "+_vm._s(_vm.task.j_sender.company_name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }